function open_select_model(){
    console.log(111111);
    event.preventDefault();
    if (document.getElementById("model-select-table").style.display == "none") {
      document.getElementById("model-select-table").style.display = "flex";
      document.getElementById("model-select-table-type").style.display = "inline-block";
      const itemHTML = [];
      const xhr = new XMLHttpRequest();
      xhr.open("GET", 'https://auton-data.fi/vehmod?tbl=1&mode=1&date=2026-10-05');
      xhr.send();
      xhr.onload = function(e) {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let responseModels = JSON.parse(xhr.responseText);
          if (responseModels.status == 0) {
            //error
          }
  
          else {
            //success

            console.log(responseModels);
            itemHTML.push("<ul>");
            for(const type in responseModels) {
              itemHTML.push( "<li data-tid='" + responseModels[type] + "'>" +  responseModels[type] + "</li>" );
            }
            itemHTML.push("</ul>");
            document.getElementById("model-select-table-type").innerHTML = itemHTML.join('');
          }
        }
      }

    }
    else {
      document.getElementById("model-select-table-type").style.display = "none";
      document.getElementById("model-select-table-brand").style.display = "none";
      document.getElementById("model-select-table-model").style.display = "none";
      document.getElementById("model-select-table").style.display = "none";
    }
}


function regSearchSubmit(event) {
  //window.location.href = "/pages/ajoneuvolle/?reg=" + document.getElementById("reg-search").value.toUpperCase() + "&type=" + Math.random();
  let regnum = document.getElementById("reg-search").value.toUpperCase();
  let collid = document.getElementById("reg-search").getAttribute("data-collid");
  
  let dbg = document.getElementById("reg-search").getAttribute("data-dbg");

    const excludedcoll = []; //excluded collections
  excludedcoll.push(
    "486734987538", //OUTLET
    "482523939090", //TARJOUKSIA
    "482524037394", //Kaikki tuotteet
    "480486916370", //New products
    "480486949138" //Best selling products
  );
  
  if( !collid || excludedcoll.includes(collid) ) {
    collid = "";
  }
  
  if (document.body.classList.contains('no-subcategories')) {
    let ptype_num = $('body.no-subcategories').attr("ptype_num");
    window.location.href = "/pages/ajoneuvolle/?reg=" + regnum + "&ptype=" + ptype_num + "&type=" + Math.random();
  }
  else{
      window.location.href = "/pages/ajoneuvolle/?reg=" + regnum + "&collection=" + collid + "&type=" + Math.random();
  }

  event.preventDefault();
}
document.addEventListener("DOMContentLoaded", function () {
  const regform = document.getElementById("reg-search-form");
  if(regform !== null) {
    regform.addEventListener("submit", regSearchSubmit);
  }
});

function searchSearchSubmit(event) {
  window.location.href = "/pages/haku/?s=" + document.getElementById("header-search").value + "&type=" + Math.random();
  event.preventDefault();
}
document.addEventListener("DOMContentLoaded", function () {
  //const searchform = document.getElementById("search-search-form");
  const searchform = document.querySelector("#shopify-section-sections--19958793437458__header .header__search form.search");
  if(searchform !== null) {
    searchform.addEventListener("submit", searchSearchSubmit);
  }
});

function isEmpty(value) {
  return (value == null || (typeof value === "string" && value.trim().length === 0));
}

function modelCheck(sub) {
  if(document.getElementById("model-search-field").style.display == "block") {
    document.getElementById("model-search-field").value = "";
    document.getElementById("model-search-field").style.display = "none";
    document.getElementById("model-search-results").style.display = "none";
    document.getElementById("model-search-results").innerHTML = "";
    if(sub == 1) {
      document.getElementById("model-select").style.display = "block";
    }
  }
  else {
    if(sub == 1) {
      document.getElementById("model-select").style.display = "none";
    }
    document.getElementById("model-search-field").value = "";
    document.getElementById("model-search-field").style.display = "block";
    const modelSearchInput = document.getElementById('model-search-field');
    modelSearchInput.focus();
    modelSearchInput.addEventListener('keyup', (event) => {
      searchString = modelSearchInput.value;

      if(searchString) {
        console.log(searchString);

        let loader = document.getElementById("loading");
    	loader.innerHTML = '<img class="loader" src="https://cdn.shopify.com/s/files/1/0763/1467/3426/files/loader.gif?v=1712063771">';
        if(sub != 1) {
          document.getElementById("model-search-results").style.display = "block";
          loader.style.display = "block";
        }
  
        // const itemHTML = [];
        // const xhr = new XMLHttpRequest();
        // xhr.open("GET", 'https://auton-data.fi/vehmod?vm=1&date=2026-10-05&st=' + searchString);
        // xhr.send();
        // xhr.onload = function(e) {
        //   console.log(3232);
        //   if (xhr.readyState === 4 && xhr.status === 200) {
        //     let responseModels = JSON.parse(xhr.responseText);
        //     if (responseModels.status == 0) {
        //       //error
        //     }
    
        //     else {
        //       //success
        //       //responseModels.forEach(function(element) {
        //         //itemHTML.push(element);
        //       //});

        //       let vehId;
        //       itemHTML.push("<ul>");
        //       for(const type in responseModels) {
        //         itemHTML.push( "<li>" + type + "<ul>" );
                
        //         const typeObj = responseModels[type];
        //         for(const brand in typeObj) {
        //           const brandObj = typeObj[brand];
        //           for(const mid in brandObj) {
        //             const midObj = brandObj[mid];
        //             for(const modelVar in midObj) {
        //               if(vehId != midObj.vehicle_id) {
        //                 if(sub != 1) {
        //                   itemHTML.push("<li data-id='" + midObj.vehicle_id + "'>" + brand  + " - " + midObj.model + "</li>");
        //                 }
        //                 else {
        //                   itemHTML.push("<li data-vid='" + midObj.vehicle_id + "'>" + brand  + " - " + midObj.model + "</li>");
        //                 }
        //                 vehId = midObj.vehicle_id;
        //               }
        //             }
        //           }
        //         }
        //         itemHTML.push("</ul></li>");
        //       }
        //       itemHTML.push("</ul>");

        //       loader.style.display = "none";
        //       document.getElementById("model-search-results").style.display = "block";
        //       document.getElementById("model-search-results").innerHTML = itemHTML.join('');

        //     }
  
        //     console.log(itemHTML);
        //   }
        // }

        const itemHTML = [];

$.ajax({
  url: 'https://auton-data.fi/vehmod',
  type: 'GET',
  data: {
    vm: 1,
    date: new Date().toISOString().split('T')[0], // same as 2026-10-05
    st: searchString
  },
  success: function(responseModels) {
    console.log(3232);

    // If response is a string, parse it
    if (typeof responseModels === "string") {
      responseModels = JSON.parse(responseModels);
    }

    if (responseModels.status == 0) {
      // error
    } else {

      let vehId;
      itemHTML.push("<ul>");

      for (const type in responseModels) {
        itemHTML.push("<li>" + type + "<ul>");

        const typeObj = responseModels[type];

        for (const brand in typeObj) {
          const brandObj = typeObj[brand];

          for (const mid in brandObj) {
            const midObj = brandObj[mid];

            for (const modelVar in midObj) {

              if (vehId != midObj.vehicle_id) {
                if (sub != 1) {
                  itemHTML.push("<li data-id='" + midObj.vehicle_id + "'>" + brand + " - " + midObj.model + "</li>");
                } else {
                  itemHTML.push("<li data-vid='" + midObj.vehicle_id + "'>" + brand + " - " + midObj.model + "</li>");
                }
                vehId = midObj.vehicle_id;
              }

            }
          }
        }

        itemHTML.push("</ul></li>");
      }

      itemHTML.push("</ul>");

      loader.style.display = "none";
      $("#model-search-results").show().html(itemHTML.join(''));
    }

    console.log(itemHTML);
  },
  error: function(xhr, status, error) {
    console.error("AJAX Error:", error);
  }
});
      }
      else {
        document.getElementById("model-search-results").innerHTML = "";
      }
    });
  }
}

document.addEventListener("click", function (event) {
  if (event.target.matches('#model-search-results [data-id]')) {
    event.preventDefault();
    let vehid = event.target.getAttribute("data-id");

    let collid = document.getElementById("model-search-results").getAttribute("data-collid");
    const excludedcoll = []; //excluded collections
    excludedcoll.push(
      "486734987538", //OUTLET
      "482523939090", //TARJOUKSIA
      "482524037394", //Kaikki tuotteet
      "480486916370", //New products
      "480486949138" //Best selling products
    );
    
    if( !collid || excludedcoll.includes(collid) ) {
      collid = "";
    }
    
    let vehname = event.target.textContent;
    vehname = vehname.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    console.log(vehid);
    console.log(vehname);
    //window.location.href = "/pages/merkki-ja-malli/?malli=" + vehname + "&id=" + vehid + "&type=" + Math.random() gf-meri;
    if (document.body.classList.contains('no-subcategories')) {
        let ptype_num = $('body.no-subcategories').attr("ptype_num");
        window.location.href = "/pages/merkki-ja-malli/?malli=" + vehname + "&id=" + vehid + "&ptype=" + ptype_num + "&type=" + Math.random();
      }
      else{
        window.location.href = "/pages/merkki-ja-malli/?malli=" + vehname + "&id=" + vehid + "&collection=" + collid + "&type=" + Math.random();
      }
    
  }
  if (event.target.matches('#model-search-results [data-vid]')) {
    event.preventDefault();
    let vehid = event.target.getAttribute("data-vid");

    let collid = document.getElementById("model-search-results").getAttribute("data-collid");
    if(!collid) {
      collid = document.getElementById("collection-id").value;
    }
    if(!collid) {
      collid = "";
    }
    
    let vehname = event.target.textContent;
    vehname = vehname.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    console.log(vehid);
    console.log(vehname);
    //window.location.href = "?malli=" + vehname + "&id=" + vehid + "&type=" + Math.random();
    // window.location.href = "?malli=" + vehname + "&id=" + vehid + "&collection=" + collid + "&type=" + Math.random();
    
    if (document.body.classList.contains('no-subcategories')) {
        let ptype_num = $('body.no-subcategories').attr("ptype_num");
        window.location.href = "?malli=" + vehname + "&id=" + vehid + "&ptype=" + ptype_num + "&type=" + Math.random();
      }
      else{
        window.location.href = "?malli=" + vehname + "&id=" + vehid + "&collection=" + collid + "&type=" + Math.random();
      }
  }
  
  // if (event.target.matches('#open-model-select-table')) {
  //   console.log(111111);
  //   event.preventDefault();
  //   if (document.getElementById("model-select-table").style.display == "none") {
  //     document.getElementById("model-select-table").style.display = "flex";
  //     document.getElementById("model-select-table-type").style.display = "inline-block";
  //     const itemHTML = [];
  //     const xhr = new XMLHttpRequest();
  //     xhr.open("GET", 'https://auton-data.fi/vehmod?tbl=1&mode=1&date=2026-10-05');
  //     xhr.send();
  //     xhr.onload = function(e) {
  //       if (xhr.readyState === 4 && xhr.status === 200) {
  //         let responseModels = JSON.parse(xhr.responseText);
  //         if (responseModels.status == 0) {
  //           //error
  //         }
  
  //         else {
  //           //success

  //           console.log(responseModels);
  //           itemHTML.push("<ul>");
  //           for(const type in responseModels) {
  //             itemHTML.push( "<li data-tid='" + responseModels[type] + "'>" +  responseModels[type] + "</li>" );
  //           }
  //           itemHTML.push("</ul>");
  //           document.getElementById("model-select-table-type").innerHTML = itemHTML.join('');
  //         }
  //       }
  //     }

  //   }
  //   else {
  //     document.getElementById("model-select-table-type").style.display = "none";
  //     document.getElementById("model-select-table-brand").style.display = "none";
  //     document.getElementById("model-select-table-model").style.display = "none";
  //     document.getElementById("model-select-table").style.display = "none";
  //   }
  // }

  if (event.target.matches('[data-tid]')) {

    let optionElems = document.querySelectorAll(".select-option-selected");
    optionElems.forEach(function (el) {
      el.classList.remove("select-option-selected");
    });
    
    let tid = event.target.getAttribute("data-tid");

    event.target.classList.add("select-option-selected");
    
    document.getElementById("model-select-table-type").style.display = "inline-block";
    document.getElementById("model-select-table-brand").style.display = "inline-block";

    const itemHTML = [];
    const xhr = new XMLHttpRequest();
    xhr.open("GET", 'https://auton-data.fi/vehmod?tbl=1&type=' + tid + '&date=2026-10-05');
    xhr.send();
    xhr.onload = function(e) {
      if (xhr.readyState === 4 && xhr.status === 200) {
        let responseModels = JSON.parse(xhr.responseText);
        if (responseModels.status == 0) {
          //error
        }

        else {
          //success

          document.getElementById("model-select-table-model").innerHTML = "";
          document.getElementById("model-select-table-brand").innerHTML = "";
          console.log("**");
          console.log(responseModels);
          itemHTML.push("<ul>");
          for(const brand in responseModels) {
            itemHTML.push( "<li data-ttid='" + tid + "' data-bid='" + responseModels[brand] + "'>" +  responseModels[brand] + "</li>" );
          }
          
          itemHTML.push("</ul>");
          document.getElementById("model-select-table-brand").innerHTML = itemHTML.join('');
          
          
        }
      }
    }

  }

  if (event.target.matches('[data-bid]')) {
    console.log("bid");
    let bid = event.target.getAttribute("data-bid");
    let tid =  event.target.getAttribute("data-ttid");

    let optionElems = document.querySelectorAll("#model-select-table-brand .select-option-selected");
    optionElems.forEach(function (el) {
      el.classList.remove("select-option-selected");
    });
    
    event.target.classList.add("select-option-selected");

    document.getElementById("model-select-table-type").style.display = "inline-block";
    document.getElementById("model-select-table-brand").style.display = "inline-block";
    document.getElementById("model-select-table-model").style.display = "inline-block";

    const itemHTML = [];
    const xhr = new XMLHttpRequest();
    xhr.open("GET", 'https://auton-data.fi/vehmod?tbl=1&ttype=' + tid +'&brand=' + bid + '&date=2026-10-05');
    xhr.send();
    xhr.onload = function(e) {
      if (xhr.readyState === 4 && xhr.status === 200) {
        let responseModels = JSON.parse(xhr.responseText);
        if (responseModels.status == 0) {
          //error
        }

        else {
          //success

          document.getElementById("model-select-table-model").innerHTML = "";
          console.log("*-*");
          console.log(responseModels);
          itemHTML.push("<ul>");

          responseModels.forEach(function (model) {
            itemHTML.push( "<li data-mid='" + model.vehicle_id + "'>" +  model.model + "</li>" );
          });
          
          itemHTML.push("</ul>");
          document.getElementById("model-select-table-model").innerHTML = itemHTML.join('');
          
        }
      }
    }

  }

  if (event.target.matches('[data-mid]')) {
    event.preventDefault();
    let vehid = event.target.getAttribute("data-mid");
    let vehname = event.target.textContent;
    let collid = document.getElementById("collection-id").value;
    if(!collid) {
      collid = "";
    }
    vehname = vehname.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    console.log(vehid);
    console.log(vehname);
    // window.location.href = "?malli=" + vehname + "&id=" + vehid + "&collection=" + collid + "&type=" + Math.random();
    if (document.body.classList.contains('no-subcategories')) {
        let ptype_num = $('body.no-subcategories').attr("ptype_num");
        window.location.href = "?malli=" + vehname + "&id=" + vehid + "&ptype=" + ptype_num + "&type=" + Math.random();
      }
      else{
       window.location.href = "?malli=" + vehname + "&id=" + vehid + "&collection=" + collid + "&type=" + Math.random();
      }
  }

  if (event.target.matches('#prodfits-title') || event.target.matches('#prodfits-title-text')) {
    document.getElementById("prodfits").classList.toggle("closed");
    document.getElementById("prodfits").classList.toggle("open");
  }  

  if (event.target.matches('#prodname')) {
    document.getElementById("prodname_et_desc").classList.toggle("closed");
    document.getElementById("prodname_et_desc").classList.toggle("open");
  }  
    
  if (event.target.matches('#oenums-title') || event.target.matches('#oenums-title-text')) {
    document.getElementById("oenums").classList.toggle("closed");
    document.getElementById("oenums").classList.toggle("open");
  }


  /* cats */
  /*
  if(event.target.matches('.cat-link')){ //main cat link
    event.preventDefault();
    let main = event.target.getAttribute("data-catid");;
    console.log("catlink click");
    console.log(main);

    const xhr = new XMLHttpRequest();
  
    let loader = document.getElementById("loading");
    loader.innerHTML = '<img class="loader" src="https://cdn.shopify.com/s/files/1/0763/1467/3426/files/loader.gif?v=1712063771">';
    
    xhr.open("GET", 'https://data.auton.fi/cats.php?cid=' + main);
    xhr.send();
    xhr.onload = function(e) {
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        let responseCats = JSON.parse(xhr.responseText);
        if (responseCats.status == 0) {
          //error
          loader.style.display = "none";
          document.getElementById("categories-title").innerHTML = responseCats.message;
        }
  
        else {
          //success
          const itemHTML = [];
          const optionsArr = [];
          console.log('level 1');
          console.log(responseCats.type);
          console.log(responseCats.data.result_type);
  
          for (const [key, value] of Object.entries(responseCats.data.options)) {
            optionsArr.push({catid: key, catname: value});
          }
          function compare( a, b ) {
            if ( a.catname < b.catname ){
              return -1;
            }
            if ( a.catname > b.catname ){
              return 1;
            }
            return 0;
          }
          optionsArr.sort(compare);
          optionsArr.forEach(function(element) {
            itemHTML.push('<li id="main-' + main + '" data-main="' + main + '"><a id="sub-' + element.catid + '" class="subcat-link" data-sub="' + element.catid + '" href="?mcat=' + main + '&scat=' + element.catid + '&type=' + Math.random() + '">' + element.catname + '</a></li>');
          });
        
          loader.style.display = "none";
          
          //document.getElementById("categories-results-cats").innerHTML = itemHTML.join('');
          document.getElementById("main-" + main + "-subs").innerHTML = itemHTML.join('');
          document.getElementById("main-" + main + "-subs").classList.toggle("item-closed");
          document.getElementById("main-" + main + "-subs").classList.toggle("item-open");
        }
      }
    }
    
  }
  else if(event.target.matches('.subcat-link')){ //main cat link
    event.preventDefault();
    console.log("subcat link click");
  }
  */
  /* /cats */
  
    
});

document.addEventListener('DOMContentLoaded', function() {
  let modelSearchForm = document.getElementById('model-search-form');
  if(modelSearchForm) {
    modelSearchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      // console.log(sasas);
      let model_handle;
      let model_id;
      let fuel;
      let year;
      let power;
      let collection;
      let category;
      if (document.getElementById("model-handle").value) {
        model_handle = "malli=" + document.getElementById("model-handle").value;
      }
      else {
        model_handle = "";
      }
      if (document.getElementById("model-id").value) {
        model_id = "&id=" + document.getElementById("model-id").value;
      }
      else {
        model_id = "";
      }
      if (document.getElementById("model-search-element-fuel-input").value && document.getElementById("model-search-element-fuel-input").value != 0) {
        fuel = "&polttoaine=" + document.getElementById("model-search-element-fuel-input").value;
      }
      else {
        fuel = "";
      }
      if (document.getElementById("model-search-element-year-input").value) {
        year = "&vuosimalli=" + document.getElementById("model-search-element-year-input").value;
      }
      else {
        year = "";
      }
      if (document.getElementById("model-search-element-power-input").value) {
        power = "&teho=" + document.getElementById("model-search-element-power-input").value;
      }
      else {
        power = "";
      }

      if (document.getElementById("collection-id").value) {
        collection = "&collection=" + document.getElementById("collection-id").value;
      }
      else {
        collection = "";
      }
      if (document.getElementById("category-id").value) {
        category = "&ptype=" + document.getElementById("category-id").value;
      }
      else {
        category = "";
      }
      
      let url = "/pages/merkki-ja-malli/?" + model_handle + model_id + fuel + power + year + collection + category + "&type=" + Math.random();
      window.location.href = url;
    });
  }
});

